import { Resource } from "./resource";
import { ResourceItem } from "./resources/ResourceItem";

export interface PostActions<TDetail extends ResourceItem> {
  postItem(item: TDetail): Promise<TDetail>;
}
export type PostResource<TDetail extends ResourceItem = any> = Resource<
  PostActions<TDetail>
>;

export function createPostResource<TDetail extends ResourceItem>(
  apiUrl: string,
  dataTransform: (data: any) => TDetail,
): PostResource<TDetail> {
  return (client) => ({
    async postItem(item) {
      const data = item.getPostData();
      const resp = await client.post(apiUrl, data);

      return dataTransform(resp.data);
    },
  });
}
